import { MAX_API_RECORDS } from "constants/index";

/**
 * Returns a suffix for API limits based on the count of records.
 * If the count is equal to the maximum allowed records,
 * it appends a "+" to indicate that there are more records available.
 * @param {number} count - The count of records.
 * @param {number} [max=MAX_API_RECORDS] - The maximum allowed records.
 * @returns {string} A suffix indicating if there are more records.
 * If count equals max, returns "+"; otherwise, returns an empty string.
 */

export default function getApiLimitSuffix(count, max = MAX_API_RECORDS) {
  return count === max ? "+" : "";
}
